export enum FeedStatusLevel {
  OK = "OK",
  ALARM = "ALARM",
}
